"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column = function Column() {
  return null;
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/lib/Column.js
// module id = 825
// module chunks = 0